import { render, staticRenderFns } from "./MeasurementData.vue?vue&type=template&id=1f58850a&scoped=true"
import script from "./MeasurementData.vue?vue&type=script&lang=js"
export * from "./MeasurementData.vue?vue&type=script&lang=js"
import style0 from "./MeasurementData.vue?vue&type=style&index=0&id=1f58850a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58850a",
  null
  
)

export default component.exports